import { FragmentSerializer } from "./FragmentSerializer";
import FootballState from "../../../../../sports/football/state/football-state";
import { getFieldDirectionMultiplier } from "../../../../../sports/football/utils/context-utils";

export class DownFragmentSerializer extends FragmentSerializer {
    isContextUpdate(fragment) {
        return fragment.associatedState === FootballState.UpdateContext;
    }

    applicable(fragment, play, serializationContext) {
        return (
            serializationContext.isDownUpdate && this.isContextUpdate(fragment)
        );
    }

    getRawFragment(play, serializationContext, updateFragment) {
        const { values } = updateFragment;
        const { down, firstDownAt } = values;

        const { gameContext } = serializationContext;
        let { fieldPosition } = gameContext;

        const distance =
            (firstDownAt - fieldPosition) *
            getFieldDirectionMultiplier(gameContext);

        return `D:${down},${distance}`;
    }
}
